import { getJobs, getStats } from '../../../services/JobsRequest'
import { Table, Tag, Radio, Button, Modal, Collapse, Descriptions, Badge } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import moment from 'moment'

const formatDate = (t) => {
    if (typeof t === 'number') return moment(t * 1000).format('YYYY-MM-DD HH:mm:ss')
    return '--'
}

const fromNow = (t) => {
    if (typeof t === 'number') return moment(t * 1000).fromNow()
    return '--'
}

const StateContent = ({ st }) => {
    return (
        <Descriptions bordered size="small" column={2}>
            {st.name === 'SCHEDULED' && (
                <>
                    <Descriptions.Item label="执行时间">{formatDate(st.scheduledAt)}</Descriptions.Item>
                    <Descriptions.Item label="reason">{st.reason}</Descriptions.Item>
                </>
            )}
            {st.name === 'ENQUEUED' && (
                <>
                    <Descriptions.Item label="入队时间">{formatDate(st.enqueuedAt)}</Descriptions.Item>
                </>
            )}
            {st.name === 'PROCESSING' && (
                <>
                    <Descriptions.Item label="serverId">{st.serverId}</Descriptions.Item>
                    <Descriptions.Item label="serverName">{st.serverName}</Descriptions.Item>
                    <Descriptions.Item label="更新时间">{formatDate(st.updatedAt)}</Descriptions.Item>
                </>
            )}
            {st.name === 'SUCCEEDED' && (
                <>
                    <Descriptions.Item label="latencyDuration">{st.latencyDuration}</Descriptions.Item>
                    <Descriptions.Item label="processDuration">{st.processDuration}</Descriptions.Item>
                </>
            )}
            {st.name === 'DELETED' && (
                <>
                    <Descriptions.Item label="reason">{st.reason}</Descriptions.Item>
                </>
            )}
            {st.name === 'FAILED' && (
                <>
                    <Descriptions.Item label="message">{st.message}</Descriptions.Item>
                    <Descriptions.Item label="exceptionType">{st.exceptionType}</Descriptions.Item>
                    <Descriptions.Item label="exceptionMessage">{st.exceptionMessage}</Descriptions.Item>
                    <Descriptions.Item label="exceptionCauseType">{st.exceptionCauseType}</Descriptions.Item>
                    <Descriptions.Item label="exceptionCauseMessage">{st.exceptionCauseMessage}</Descriptions.Item>
                    <Descriptions.Item label="stackTrace">{st.stackTrace}</Descriptions.Item>
                </>
            )}
        </Descriptions>
    )
}

const StateBar = ({ state, setState }) => {
    const [stats, setStats] = useState({})

    const fetch = useCallback(() => {
        getStats().then((s) => setStats(s))
    }, [])

    useEffect(() => {
        fetch()
    }, [fetch])

    return (
        <div style={{ marginBottom: 24 }}>
            状态：{' '}
            <Radio.Group value={state} onChange={(e) => setState(e.target.value)}>
                <Radio.Button value="SCHEDULED">
                    <Badge status="default" />
                    计划({stats.scheduled})
                </Radio.Button>
                <Radio.Button value="ENQUEUED">
                    <Badge status="warning" />
                    入队({stats.enqueued})
                </Radio.Button>
                <Radio.Button value="PROCESSING">
                    <Badge status="processing" />
                    执行中({stats.processing})
                </Radio.Button>
                <Radio.Button value="FAILED">
                    <Badge status="error" />
                    失败({stats.failed})
                </Radio.Button>
                <Radio.Button value="SUCCEEDED">
                    <Badge status="success" />
                    成功({stats.succeeded})
                </Radio.Button>
                <Radio.Button value="DELETED">已删除({stats.deleted})</Radio.Button>
            </Radio.Group>
            <span
                onClick={() => fetch()}
                role="button"
                style={{ color: 'rgba(0,0,0,.6)', paddingLeft: 16, cursor: 'pointer' }}
            >
                刷新状态
            </span>
        </div>
    )
}

const Jobs = () => {
    const [jobs, setJobs] = useState({})
    const [state, setState] = useState('SCHEDULED')
    const [modal, setModal] = useState({ visible: false, states: [] })

    const fetchData = useCallback(
        (page = 0, size = 20) => {
            getJobs({ stateName: state, page, size }).then((jobs) => setJobs(jobs))
        },
        [state]
    )

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <div>
            <StateBar state={state} setState={setState} />
            <Table
                rowKey={'id'}
                dataSource={jobs.items}
                columns={[
                    { title: 'Id', dataIndex: 'id' },
                    {
                        title: 'Job details	',
                        render: (row) => {
                            return (
                                <>
                                    <div>
                                        {row.labels.map((t) => (
                                            <Tag key={t}>{t}</Tag>
                                        ))}
                                    </div>
                                </>
                            )
                        },
                    },
                    {
                        title: 'State',
                        dataIndex: ['jobState'],
                        render: (state) => {
                            if (state.name === 'SCHEDULED') {
                                return `${formatDate(state.scheduledAt)} 【${fromNow(state.scheduledAt)}】`
                            }
                            return state.name
                        },
                    },
                    {
                        title: '详情',
                        dataIndex: ['jobStates'],
                        render: (states) => {
                            return <Button onClick={() => setModal({ visible: true, states })}>查看</Button>
                        },
                    },
                ]}
                pagination={{
                    total: jobs.total,
                    current: jobs.currentPage + 1,
                    pageSize: jobs.limit,
                    onChange: (page, size) => fetchData(page - 1, size),
                }}
            />
            <Modal
                width={800}
                visible={modal.visible}
                title="任务详情"
                onOk={() => setModal({ visible: false, states: [] })}
                onCancel={() => setModal({ visible: false, states: [] })}
                cancelButtonProps={{ hidden: true }}
            >
                <Collapse>
                    {modal.states.map((st) => (
                        <Collapse.Panel header={`${st.name} ${formatDate(st.createdAt)}`} key={st.name}>
                            <StateContent st={st} />
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </Modal>
        </div>
    )
}

export default Jobs
